import { gql } from 'apollo-boost'

const SCRAPING_TAGS_FOR_TYPE = gql`
  query scrapingTagsForType($type: ScrapingTagType!) {
    scrapingTagsForType(type: $type) {
      id
      name
    }
  }
`

export default SCRAPING_TAGS_FOR_TYPE
